/**
 * ForeshadowPassiveSkillEffect — Astral oracle-path passive: conditional
 * Foresight arc extension while Temporal Echo records.
 *
 * Code-only passive. When this node unlocks, its effect value
 * (`foresightDurationBonus: 200`) becomes visible to the resolver. The
 * actual arc extension logic lives in ForesightPassiveSkillEffect, which
 * queries the resolver for the bonus and gates it behind
 * TemporalEchoStateSystem.isRecording.
 *
 * This class carries no runtime behavior — it is a pure marker that the
 * node is unlocked. The tree JSON provides the effect value; the resolver
 * aggregates it; ForesightPassive consumes it conditionally.
 *
 * Pure logic — no Phaser dependencies.
 *
 * @see astral-spec.md § temporal_echo_passive
 * @see ADR-064 (attunement shared systems architecture)
 */

import type { SkillEffect } from '../../SkillEffect.js';

// ---------------------------------------------------------------------------
// Skill effect
// ---------------------------------------------------------------------------

export class ForeshadowPassiveSkillEffect implements SkillEffect {
  readonly skillId = 'temporal_echo_passive';
  readonly type = 'passive' as const;
  readonly activationMode = 'instant' as const;

  // --- SkillEffect interface ---

  activate(): boolean { return false; }
  isActive(): boolean { return false; }
  update(_delta: number): void { /* passive — nothing to tick */ }
  destroy(): void { /* no-op marker passive */ }
}
